import { ORIGINAL_SAVE_FORMAT_MANIFEST } from "../data/generated/original-save-format-manifest";

type KeyCrosswalk = {
  party: Record<string, unknown>;
  groups: Record<string, unknown>;
  globals: Record<string, unknown>;
};

const KEY_CROSSWALK = ORIGINAL_SAVE_FORMAT_MANIFEST.decodedSaveRules.keyCrosswalk as KeyCrosswalk;

export const ORIGINAL_SAVE_RUNTIME_CONSUMPTION = {
  manifest: "docs/original-save-format-manifest.json",
  generatedManifestModule: "web/src/data/generated/original-save-format-manifest.ts",
  consumesDecodedSaveFormat: true,
  sourceBackedStatus: ORIGINAL_SAVE_FORMAT_MANIFEST.status,
  sourceBackedCriteria: {
    sectionSelectionDecoded: ORIGINAL_SAVE_FORMAT_MANIFEST.criteria.sectionSelectionDecoded,
    dataSentinelDecoded: ORIGINAL_SAVE_FORMAT_MANIFEST.criteria.dataSentinelDecoded,
    partyStatKeysDecoded: ORIGINAL_SAVE_FORMAT_MANIFEST.criteria.partyStatKeysDecoded,
    itemMagicKeysDecoded: ORIGINAL_SAVE_FORMAT_MANIFEST.criteria.itemMagicKeysDecoded,
    globalStateKeysDecoded: ORIGINAL_SAVE_FORMAT_MANIFEST.criteria.globalStateKeysDecoded,
    missingDataFlowDecoded: ORIGINAL_SAVE_FORMAT_MANIFEST.criteria.missingDataFlowDecoded,
    loadPostProcessingDecoded: ORIGINAL_SAVE_FORMAT_MANIFEST.criteria.loadPostProcessingDecoded,
    saveCompletionMessageDecoded: ORIGINAL_SAVE_FORMAT_MANIFEST.criteria.saveCompletionMessageDecoded,
    frmFullDecodeNotRequiredForSaveGate: ORIGINAL_SAVE_FORMAT_MANIFEST.criteria.frmFullDecodeNotRequiredForSaveGate
  },
  keyCrosswalk: {
    party: Object.keys(KEY_CROSSWALK.party),
    groups: Object.keys(KEY_CROSSWALK.groups),
    globals: Object.keys(KEY_CROSSWALK.globals)
  }
} as const;

export function originalSaveRuntimeConsumesDecodedSaveFormat(): boolean {
  return ORIGINAL_SAVE_RUNTIME_CONSUMPTION.consumesDecodedSaveFormat;
}

export function originalSaveSectionHeader(sectionName: string): string {
  return `[${sectionName}]`;
}

export function originalSaveDataSentinelLine(): string {
  return "Data=1";
}

export function originalSavePartyKey(key: string, index: number): string {
  assertKnownKey(KEY_CROSSWALK.party, key, "party");
  return `${key} ${index}`;
}

export function originalSaveGroupedKey(group: string, index: number): string {
  assertKnownKey(KEY_CROSSWALK.groups, group, "group");
  return `${group} ${index}`;
}

export function originalSaveGlobalKey(key: string): string {
  assertKnownKey(KEY_CROSSWALK.globals, key, "global");
  return key;
}

export function originalSaveParseValues(text: string): Record<string, string> {
  const values: Record<string, string> = {};
  text.split(/\r?\n/).forEach((raw) => {
    const line = raw.trim();
    if (!line || line.startsWith("[") || !line.includes("=")) return;
    const [key, ...rest] = line.split("=");
    values[key.trim()] = rest.join("=").trim();
  });
  return values;
}

function assertKnownKey(record: Record<string, unknown>, key: string, family: string): void {
  if (!Object.prototype.hasOwnProperty.call(record, key)) {
    throw new Error(`Unknown original save ${family} key: ${key}`);
  }
}
